import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

type TabType = "reports" | "templates";

type Tab = {
  id: TabType;
  displayElement: React.ReactNode;
  disabled?: boolean;
};

type UseManageReportsTabs = {
  currentTab: TabType;
  tabs: Tab[];
  handleClickTab: (tab: Tab) => void;
};

export const useManageReportsTabs = (): UseManageReportsTabs => {
  const [currentTab, setCurrentTab] = useState<TabType>("reports");
  const { t } = useTranslation("bookingModule");

  const tabs: Tab[] = useMemo(
    () => [
      { id: "reports", displayElement: t("reports.manageReports.reports.tabTitle") },
      { id: "templates", displayElement: t("reports.manageReports.templates.tabTitle") }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleClickTab = (tab: Tab) => setCurrentTab(tab.id);

  return {
    currentTab,
    tabs,
    handleClickTab
  };
};
